import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';

export default class CrmCaseStatusTransfer extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: props.Id,
            caller: props.Caller,
            statusList: props.StatusList,
            loading: false,
            selectedStatusId: this.getDefaultGuid()
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    save(e) {
        if (!this.isNull(e)) e.preventDefault();

        this.httpPost("api/v1/crm/casestatus/transfer", {
            id: this.state.id,
            toStatusId: this.state.selectedStatusId,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("انتقال با موفقیت ذخیره شد");
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable" style={{ "minWidth": "60%" }}>
                    <div className="modal-content">
                        <div className="modal-body" style={{ "padding": "0" }}>
                            <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                                <h4 className="modal-title">انتقال محتوای وضعیت</h4>
                            </div>
                            <div className="modal-body">
                                <div className="container-fluid">
                                    <div className="row">
                                    <div className="col-sm-3">
                                        <div className="form-group">
                                            <label for="name" className="title1">انتخاب وضعیت مورد نظر</label>
                                            <select defaultValue={this.state.selectedStatusId} onChange={e => this.state.selectedStatusId = e.target.value} type="text" className="form-control input-sm">
                                                <option value={this.getDefaultGuid()}>انتخاب نمایید</option>
                                                {this.state.statusList.map(item =>
                                                    item.id !== this.state.id && <option value = { item.id }> { item.title }</option>
                                                )}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-sm-12">
                                        <div className="form-group">
                                            <p className="text-danger">توجه: با انجام این عملیات، کلیه پیگیریها و سوابق و فیلدهای اختصاصی این وضعیت، به وضعیت انتخاب شده در بالا منتقل خواهد شد</p>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                            <button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closeMe()}>انصراف</button>
                                <button type="submit" onClick={e => this.save(e)} className="btn btn-success">
                                    انتقال
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm()
            ];

        return contents;
    }
}